import React, { Component } from "react";
import "./App.css";
import CodeSnippet from "./components/CodeSnippet";
import DeveloperOptions from "./components/DeveloperOptions";
import ResultingUI from "./components/ResultingUI";
import CodeTabs from "./components/CodeTabs";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apSettings: {
                audio: true,
                numHumans: true,
                tabSwitch: true,
                photosAtRandom: false,
                detectMultipleScreens: true,
                forceFullScreen: false,
                auxiliaryDevice: new URLSearchParams(window.location.search).get("aux") ? true : false,
                recordSession: true,
            },
            currentTab: "html",
            isAuxDevice: new URLSearchParams(window.location.search).get("aux") ? true : false,
        };
    }

    handleInputChange = (event) => {
        const target = event.target;
        this.setState({
            apSettings: { ...this.state.apSettings, [target.name]: target.checked },
        });
    };

    handleTabChange = (tab) => {
        this.setState({
            currentTab: tab,
        });
    };

    render() {
        let { clientId, clientSecret } = this.props;

        const codeSnippets = {
            html: `    <script src="https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js"></script>
    <!-- Link to a CSS file here that contains the same code as on the CSS tab above -->    
    <script src="https://cdn.autoproctor.co/ap-entry.js"></script>
    
    <div class="container" id="ap-proctoring-container">
       <div class="ctas">
          <button id="btn-start">Start</button>
          <button id="btn-stop">Stop</button>
       </div>
       <div class="flex flex-row">
          <div id="ap-test-proctoring-status"></div>
          <div id="proctor-feedback"></div>
       </div>
    </div>
    <div class="container mx-auto mt-8 max-w-5xl" id="ap-report__overview"></div>
    <div class="container mx-auto mt-8 max-w-5xl" id="ap-report-tab-container"></div>
    
    <!-- Link to a JS file here that contains the same code as on the JavaScript tab above -->
    
    <script>
        const proctoringOptions = {
            trackingOptions: { 
                audio: ${this.state?.apSettings.audio},
                numHumans: ${this.state?.apSettings.numHumans},
                tabSwitch: ${this.state?.apSettings.tabSwitch},
                photosAtRandom: ${this.state?.apSettings.photosAtRandom},
                detectMultipleScreens: ${this.state?.apSettings.detectMultipleScreens},
                forceFullScreen: ${this.state?.apSettings.forceFullScreen},
                auxiliaryDevice: ${this.state?.apSettings.auxiliaryDevice},
                recordSession: ${this.state?.apSettings.recordSession}
            },
            showHowToVideo: false, ${
                this.state?.apSettings.forceFullScreen
                    ? "\n            testContainerId: 'test-container', // Add the DOM id of your test container element here"
                    : ""
            } ${
                this.state?.apSettings.auxiliaryDevice
                    ? "\n            auxDeviceTestContainerId: 'test-container', // Add the DOM id of your auxiliary test container element here"
                    : ""
            }
        };

        async function init() {
            const credentials = getCredentials();
            const apInstance = new AutoProctor(credentials);
            await apInstance.setup(proctoringOptions);
            document.getElementById("btn-start").addEventListener("click", () => apInstance.start());
            window.addEventListener("apMonitoringStarted", () => {
                document.getElementById("btn-start").disabled = true;
                document.getElementById("btn-stop").disabled = false;
                document.getElementById("ap-test-proctoring-status").innerHTML = "Proctoring...";
            })
            document.getElementById("btn-stop").addEventListener("click", () => apInstance.stop());
            window.addEventListener("apMonitoringStopped", async () => {
                const reportOptions = getReportOptions();
                apInstance.showReport(reportOptions);
                document.getElementById("ap-proctoring-container").visibility = "hidden";
                document.getElementById("ap-test-proctoring-status").innerHTML = "Proctoring stopped";
            })
        }

        window.addEventListener("load", init);
    </script>
        `,
            css: ` 
    /* Styling for .container class */
     .container {
         margin: 0 auto;
         max-width: 1200px;
         padding: 20px;
    }
    
    /* Styling for .grid class */
     .ctas {
         display: grid;
         grid-template-columns: repeat(3, 1fr);
         gap: 10px;
    }
    
    /* Styling for button elements inside .grid */
     .ctas button {
         padding: 10px;
         border: none;
         border-radius: 5px;
         cursor: pointer;
    }
    
    /* Styling for # start button */
     #btn-start {
         background-color: green;
         color: white;
    }
    
    /* Styling for #testEnd button */
     #btn-stop {
         background-color: red;
         color: white;
    }
    
    /* Styling for .flex class */
     .flex {
         display: flex;
         align-items: center;
    }
    
    /* Styling for #ap-test-proctoring-status element */
     #ap-test-proctoring-status {
         margin-bottom: 2px;
         font-size: 3rem;
         font-weight: bold;
         margin-left: 14px;
         animation: pulse 2s infinite;
    }
     @keyframes pulse {
         0% {
             opacity: 1;
        }
         50% {
             opacity: 0.5;
        }
         100% {
             opacity: 1;
        }
    }
    
    /* Styling for #proctor-feedback element */
     #proctor-feedback {
         margin-bottom: 2px;
         background: none;
         border-radius: 9999px;
         transition: all 0.3s;
         color: #ff9800;
         font-weight: bolder;
         font-size: 0.75rem;
         padding: 8px 16px;
         text-transform: uppercase;
         letter-spacing: 0.1em;
    }
    
    /* Styling for #test-attempt-report container */
     #test-attempt-report {
         display: none;
    }
    
    /* Styling for #ap-test-report-overview element */
     #ap-test-report-overview {
         max-width: 72rem;
         margin: 0 auto;
         background-image: linear-gradient( to right, var(--gradient-from), var(--gradient-to) );
         padding: 10px;
         border-radius: 1rem;
         box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
    
    /* Styling for .flex element inside #test-attempt-report container */
     #test-attempt-report .flex {
         margin-top: 1rem;
    }
    
    /* Styling for .tab-button class */
     .tab-button {
         padding: 0.5rem 1rem;
         border: none;
         border-radius: 0.25rem;
         cursor: pointer;
         text-transform: uppercase;
         letter-spacing: 0.1em;
    }
    
    /* Styling for #tab-1 button */
    
    /* Styling for #tab-1-content and #tab-2-content elements */
     #tab-1-content, #tab-2-content {
         max-width: 72rem;
         margin: 0 auto;
         background-image: linear-gradient( to left, var(--gradient-from), var(--gradient-to) );
         padding: 10px;
         border-radius: 1rem;
         box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
    
    /* Styling for .max-w-5xl class */
     .max-w-5xl {
         max-width: 72rem;
    }
    
    /* Styling for h1 tag */
     .container h1 {
         font-size: 1.5rem;
         margin: 1rem 0;
    }
    
    /* Styling for .text-2xl class */
     .text-2xl {
         font-size: 1.25rem;
    }
    
    /* Styling for .text-3xl class */
     .text-3xl {
         font-size: 1.875rem;
    }
    
    /* Styling for .text-center class */
     .text-center {
         text-align: center;
    }
    
    /* Styling for .my-4 class */
     .my-4 {
         margin: 1rem 0;
    }
    
    /* Styling for .bg-gradient-to-l class */
     .bg-gradient-to-l {
         background-image: linear-gradient( to left, var(--gradient-from), var(--gradient-to) );
    }
    
    /* Styling for .p-10 class */
     .p-10 {
         padding: 2.5rem;
    }
    
    /* Styling for .rounded-2xl class */
     .rounded-2xl {
         border-radius: 2rem;
    }
    
    /* Styling for .shadow-2xl class */
     .shadow-2xl {
         box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    }
     .my-10 {
         margin-top: 2.5rem;
         margin-bottom: 2.5rem;
    }
    
    /* Styling for .bg-blue-300 class */
     .bg-blue-300 {
         background-color: #2196f3;
    }
    
    /* Styling for .bg-gray-500 class */
     .bg-gray-500 {
         background-color: #6b7280;
    }
    
    /* Styling for .text-gray-700 class */
     .text-gray-700 {
         color: #4b5563;
    }
    
    /* Styling for .text-white class */
     .text-white {
         color: #ffffff;
    }
     `,
            javascript: `
    const CLIENT_ID = null; // INSERT YOUR ID HERE!!!!
    const CLIENT_SECRET = null; // INSERT YOUR SECRET HERE!!!!    
    const getTestAttemptId = () => Math.random().toString(36).slice(2, 7);
    
    function getHashTestAttemptId(testAttemptId) {
        if (CLIENT_SECRET === null) {
            return null;
        } else {
            const secretWordArray = CryptoJS.enc.Utf8.parse(CLIENT_SECRET);
            const messageWordArray = CryptoJS.enc.Utf8.parse(testAttemptId);
            const hash = CryptoJS.HmacSHA256(messageWordArray, secretWordArray);
            const base64HashedString = CryptoJS.enc.Base64.stringify(hash);
            return base64HashedString;
        }
    }    
    
    function getCredentials() {
        const testAttemptId = getTestAttemptId();
        const hashedTestAttemptId = getHashTestAttemptId(testAttemptId, CLIENT_SECRET);
        const creds = {
            clientId: CLIENT_ID,
            testAttemptId: testAttemptId,
            hashedTestAttemptId: hashedTestAttemptId
        };
        return creds;
    }    
    
    const getReportOptions = () => {
        return {
            groupReportsIntoTabs: true,
            userDetails: {
                name: "First Last",
                email: "user@gmail.com"
            }
        };
    };
    
        `,
        };

        function handleCopy(e, copyText) {
            navigator.clipboard.writeText(copyText);
            const ele = document.getElementById("btn-copy-code");
            ele.innerText = "Copied";
            setTimeout(() => {
                ele.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" style="width:16px; height: 16px;" viewBox="0 0 12 17" fill="none">
                <path d="M5 0.240967C4.44772 0.240967 4 0.688682 4 1.24097C4 1.79325 4.44772 2.24097 5 2.24097H7C7.55228 2.24097 8 1.79325 8 1.24097C8 0.688682 7.55228 0.240967 7 0.240967H5Z" fill="#D1D5DB"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.24097C0 2.1364 0.895431 1.24097 2 1.24097C2 2.89782 3.34315 4.24097 5 4.24097H7C8.65685 4.24097 10 2.89782 10 1.24097C11.1046 1.24097 12 2.1364 12 3.24097V14.241C12 15.3455 11.1046 16.241 10 16.241H2C0.895431 16.241 0 15.3455 0 14.241V3.24097ZM9.70711 8.94807C10.0976 8.55755 10.0976 7.92438 9.70711 7.53386C9.31658 7.14334 8.68342 7.14334 8.29289 7.53386L5 10.8268L3.70711 9.53386C3.31658 9.14334 2.68342 9.14334 2.29289 9.53386C1.90237 9.92438 1.90237 10.5575 2.29289 10.9481L4.29289 12.9481C4.68342 13.3386 5.31658 13.3386 5.70711 12.9481L9.70711 8.94807Z" fill="#D1D5DB"/>
            </svg>
                `;
            }, 1500);
        }

        const proctoringOptions = {
            trackingOptions: {
                audio: this.state?.apSettings.audio,
                numHumans: this.state?.apSettings.numHumans,
                tabSwitch: this.state?.apSettings.tabSwitch,
                photosAtRandom: this.state?.apSettings.photosAtRandom,
                detectMultipleScreens: this.state?.apSettings.detectMultipleScreens,
                forceFullScreen: this.state?.apSettings.forceFullScreen,
                auxiliaryDevice: this.state?.apSettings.auxiliaryDevice,
                recordSession: this.state?.apSettings.recordSession,
            },
            showHowToVideo: false,
        };

        return (
            <>
                {this.state.isAuxDevice ? (
                    <ResultingUI
                        clientId={clientId}
                        clientSecret={clientSecret}
                        proctoringOptions={proctoringOptions}
                        domain={this.props.domain || "https://dev.autoproctor.co"}
                        isAuxDevice={this.state.isAuxDevice}
                    />
                ) : (
                    <>
                        <div id="ap-playground-ctr" className={"bg-white text-zinc-400 -mt-5 pt-5 " + (this.state.isAuxDevice ? "" : "hidden lg:block")}>
                            <DeveloperOptions
                                currSetting={this.state.apSettings}
                                handleInputChange={this.handleInputChange}
                            />
                            <div
                                style={{
                                    height: "calc(100vh - 152px)",
                                }}
                                className="row playground pt-6 pb-2 px-5 bg-white flex gap-7 !items-start"
                            >
                                <div className="column h-full overflow-auto resulting-ui">
                                    <ResultingUI
                                        clientId={clientId}
                                        clientSecret={clientSecret}
                                        proctoringOptions={proctoringOptions}
                                        domain={this.props.domain || "https://dev.autoproctor.co"}
                                    />
                                </div>
                                <div
                                    className="column h-full relative bg-black rounded-lg border-2 border-black"
                                    style={{
                                        maxHeight: "calc(100vh - 150px)",
                                    }}
                                >
                                    <button
                                        id="btn-copy-code"
                                        className="absolute right-3 top-2.5 p-2 text-white text-xs bg-neutral-600/50 hover:bg-neutral-900/10 rounded-md flex flex-row items-center z-10"
                                        onClick={(e) => {
                                            handleCopy(e, codeSnippets[this.state.currentTab]);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-4 h-4"
                                            viewBox="0 0 12 17"
                                            fill="none"
                                        >
                                            <path
                                                d="M5 0.240967C4.44772 0.240967 4 0.688682 4 1.24097C4 1.79325 4.44772 2.24097 5 2.24097H7C7.55228 2.24097 8 1.79325 8 1.24097C8 0.688682 7.55228 0.240967 7 0.240967H5Z"
                                                fill="#D1D5DB"
                                            />
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M0 3.24097C0 2.1364 0.895431 1.24097 2 1.24097C2 2.89782 3.34315 4.24097 5 4.24097H7C8.65685 4.24097 10 2.89782 10 1.24097C11.1046 1.24097 12 2.1364 12 3.24097V14.241C12 15.3455 11.1046 16.241 10 16.241H2C0.895431 16.241 0 15.3455 0 14.241V3.24097ZM9.70711 8.94807C10.0976 8.55755 10.0976 7.92438 9.70711 7.53386C9.31658 7.14334 8.68342 7.14334 8.29289 7.53386L5 10.8268L3.70711 9.53386C3.31658 9.14334 2.68342 9.14334 2.29289 9.53386C1.90237 9.92438 1.90237 10.5575 2.29289 10.9481L4.29289 12.9481C4.68342 13.3386 5.31658 13.3386 5.70711 12.9481L9.70711 8.94807Z"
                                                fill="#D1D5DB"
                                            />
                                        </svg>
                                    </button>
                                    <CodeTabs
                                        handleTabChange={this.handleTabChange}
                                        currentTab={this.state.currentTab}
                                    />
                                    <CodeSnippet
                                        currSetting={this.state.apSettings}
                                        codeString={codeSnippets[this.state.currentTab]}
                                        language={this.state.currentTab}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                (!this.state.isAuxDevice ? "grid items-center text-center lg:hidden" : "hidden ") + " bg-zinc-900 text-zinc-400 h-screen w-screentext-xl px-5 "
                                
                            }
                        >
                            Please access the Playground on a larger screen like a laptop or a desktop.
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default App;
